import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const WalletDataResponseSchema = z
  .object({
    data: z.object({
      btc_balance: z.object({
        amount: z.number(),
        is_increased: z.boolean(),
        usd_amount: z.number(),
        locked_amount: z.number(),
      }),
    }),
  })
  .transform((data) => transformKeysToCamelCase(data));

export type TWalletDataResponse = z.infer<typeof WalletDataResponseSchema>;
export type TWalletBTCBalanceData = TWalletDataResponse['data'];
export type TWalletBTC = TWalletBTCBalanceData['btcBalance'];
